import ManualBreadcrumb from '../../components/manual/ManualBreadcrumb';
import ManualSection from '../../components/manual/ManualSection';
import ManualAlert from '../../components/manual/ManualAlert';

function ManualPerguntasFrequentesPage() {
  return (
    <div className="manual-page">
      <ManualBreadcrumb items={[{ label: 'Perguntas Frequentes' }]} />
      
      <div className="manual-header">
        <h1 className="manual-title">
          <i className="bi bi-question-circle me-3"></i>
          Perguntas Frequentes
        </h1>
        <p className="manual-subtitle">
          Respostas para as dúvidas mais comuns
        </p>
      </div>

      <ManualSection icon="bi-key" title="Login e Acesso">
        <div className="manual-faq-item">
          <h5>Esqueci minha senha. O que faço?</h5>
          <p>
            Entre em contato com o administrador do sistema na SEJUS.  Se você tem e-mail institucional (@sejus.df.gov.br), sua senha é a mesma do Windows.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>Não consigo fazer login. Qual pode ser o problema?</h5>
          <p>
            Verifique se está digitando corretamente e-mail e senha. Senhas diferenciam maiúsculas de minúsculas.
            Se o problema persistir, limpe o cache do navegador ou tente outro navegador.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>Meu acesso expirou. Como renovar?</h5>
          <p>
            Entre em contato com o administrador do sistema para reativar seu acesso.
          </p>
        </div>
      </ManualSection>

      <ManualSection icon="bi-people" title="Adolescentes">
        <div className="manual-faq-item">
          <h5>Posso cadastrar um adolescente sem o número da Jornada?</h5>
          <p>
            Sim, o número da Jornada não é obrigatório. Você pode cadastrar apenas com nome, data de nascimento, sexo e identidade de gênero.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>Como corrigir um erro no cadastro de um adolescente?</h5>
          <p>
            Se você tem permissão de edição, acesse a página do adolescente e clique em "Editar".
            Se não tiver permissão, peça ao administrador ou supervisor.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>Posso excluir um adolescente cadastrado por engano?</h5>
          <p>
            Não. O sistema não permite exclusão para manter o histórico completo.
            Se houver erro grave, entre em contato com o administrador do sistema.
          </p>
        </div>
      </ManualSection>

      <ManualSection icon="bi-arrow-left-right" title="Movimentações">
        <div className="manual-faq-item">
          <h5>Posso criar várias movimentações para o mesmo adolescente?</h5>
          <p>
            Sim! Cada entrada no sistema gera uma nova movimentação. Um adolescente pode ter várias movimentações ao longo do tempo.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>O que acontece se eu finalizar uma movimentação por engano?</h5>
          <p>
            Movimentações finalizadas não podem ser editadas. Entre em contato com o administrador se precisar corrigir algo.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>É obrigatório preencher todos os atendimentos?</h5>
          <p>
            Não. Preencha apenas os atendimentos que realmente aconteceram. Se não houve atendimento de uma área, deixe em branco.
          </p>
        </div>
      </ManualSection>

      <ManualSection icon="bi-shield-lock" title="Permissões">
        <div className="manual-faq-item">
          <h5>Não vejo alguns menus ou botões. Por quê?</h5>
          <p>
            Seu perfil de usuário determina o que você pode ver e fazer no sistema.
            Se você precisa de mais permissões, fale com seu supervisor ou administrador.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>Como sei quais permissões eu tenho?</h5>
          <p>
            Você verá apenas os menus e botões que está autorizado a usar. Se algo não aparece, é porque você não tem permissão para aquela funcionalidade.
          </p>
        </div>
      </ManualSection>

      <ManualSection icon="bi-exclamation-triangle" title="Problemas Técnicos">
        <div className="manual-faq-item">
          <h5>O sistema está lento. O que fazer?</h5>
          <p>
            Pode ser tráfego alto. Aguarde alguns minutos e tente novamente.
            Se o problema persistir, feche e abra o navegador, ou limpe o cache.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>Salvei mas as informações não aparecem. Por quê?</h5>
          <p>
            Recarregue a página (F5). Se o problema continuar, pode ter havido erro ao salvar.
            Verifique se você estava conectado à internet e tente novamente.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>Os gráficos do dashboard não aparecem.</h5>
          <p>
            Tente atualizar a página. Se não resolver, pode ser problema de compatibilidade do navegador.
            Recomendamos usar Google Chrome ou Microsoft Edge atualizados.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>Recebi uma mensagem de erro. O que significa?</h5>
          <p>
            Leia a mensagem com atenção. Geralmente ela explica o que está errado.
            Se não entender, anote o texto exato do erro e reporte ao suporte técnico.
          </p>
        </div>
      </ManualSection>

      <ManualAlert type="info" title="Não encontrou sua dúvida?">
        Entre em contato com o suporte técnico da SEJUS pelo telefone ou e-mail fornecido em sua unidade.
        Tenha em mãos informações como seu nome de usuário e descrição detalhada do problema.
      </ManualAlert>
    </div>
  );
}

export default ManualPerguntasFrequentesPage;
